import { merchantApi } from '@/config/axios'

/** 平台快递公司精简信息（商家发货下拉用） */
export interface DeliveryExpressSimpleVO {
  id: number
  name: string
}

/** 获得开启的快递公司精简列表 */
export const getSimpleDeliveryExpressList = () => {
  return merchantApi.get<DeliveryExpressSimpleVO[]>({
    url: '/merchant-api/trade/delivery/express/list-all-simple'
  })
}
